// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components'

// COMPONENTS IMPORTS //
import LanguagesBackground from './LanguageBackground/LanguageBackground'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import {
  Themes,
  GlobalStyles,
  iPadResolution,
} from 'Content/Shared/Styles/Theme'
import { nowJob } from 'Content/Shared/Helpers/Constants'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const HeaderInfo: React.FC<PropsType> = () => {
  return (
    <Wrapper>
      <h1>About Artem</h1>

      <Row>
        <TextWrap>
          Hello friends! I am Artem, a 16 years old self-taught{' '}
          <Bold>Full-Stack software developer</Bold>. <br />
          Currently based in Spain, Alicante, but originally hail from Russia,
          Moscow. <br />
          <br /> Well-organised person, problem solver and an independent
          employee with high attention to detail.
          {/* <br /> Specialised in architecting and building{' '}
          <Bold>
            (Javascript Web and Backend apps) and (iOS cross-platform apps)
          </Bold>
          . */}
          <br />
          Interested in working on ambitious projects with positive people.
          <br />
          <Bold>Current Objectives</Bold>: Learning Data Science and Machine
          Learning technologies.
          <br />
          <br />
          Currenty working as a <Bold>{nowJob.title}</Bold> at{' '}
          <Link href={nowJob.link} target={'_blank'}>
            <Bold>{nowJob.place}</Bold>
          </Link>
          .
          <br />
          <br />
          Outside of coding I am a professional swimmer and a begginer
          calisthenics athlete. I am deeply interested in Mathematics and its
          applications in Machine Learning and Software development.
          <br />
          I'm always down to collaborate when I have the time. Reach out and
          let's chat! ✌️
          <Link href={nowJob.cvLink} target={'_blank'}>
            <Bold>Click to open my CV</Bold>
          </Link>
        </TextWrap>

        <Image />
      </Row>

      <LanguagesBackground />
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const WRAPPER_PADDING = 30
const Wrapper = styled.div`
  background-color: ${Themes.card.backgroundColor};
  box-shadow: ${Themes.card.boxShadow};
  padding: ${WRAPPER_PADDING - 20}px ${WRAPPER_PADDING + 10}px
    ${WRAPPER_PADDING}px ${WRAPPER_PADDING}px;
  border-radius: ${GlobalStyles.borderRadius}px;
  padding-bottom: 4px;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
`

const Image = styled.div`
  background-color: gray;
  border-radius: 16px;
  margin-left: 50px;
  margin-top: -20px;
  margin-bottom: 60px;
  flex: 1;
  height: 170px;

  @media (max-width: ${iPadResolution + 34}px) {
    display: none;
  }
`
const TextWrap = styled.div`
  line-height: 23px;
  letter-spacing: 0.2px;
  flex: 3.5;
`

const Link = styled.a`
  color: ${Themes.colors.primary};
`

const Bold = styled.span`
  font-weight: bold;
`

export default React.memo(HeaderInfo, memoComparison)
